import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.totalsFormSection.title',
    defaultMessage: 'Totals',
    description: 'Title of the totals form section',
  },
  button: {
    discounts: {
      label: {
        id: 'pages.totalsFormSection.button.discounts.label',
        defaultMessage: 'Discounts',
        description: 'Label of the discounts button in the totals form section',
      },
    },
  },
  addDiscount: {
    title: {
      id: 'pages.addDiscount.title',
      defaultMessage: 'Add discount',
      description: 'Title of the add discount drawer in the totals form section',
    },
  },
};

export default defineMessages(translations);
